var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-loading',{attrs:{"is-full-page":true,"can-cancel":true},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }